import config from '@/config'
import { PaymentProvidersResponse } from '@gohighlevel/ghl-proposals-common'
import { requests } from '.'

export const PaymentService = {
  getCurrencyDetails: () => requests(config.PAYMENTS_SERVICE_URL).get(`/currency`),

  fetchPaymentSettings: (locationId: string) =>
    requests(config.PAYMENTS_SERVICE_URL).get(`/payment-settings?altId=${locationId}&altType=location`),
  fetchPaymentIntegrations: (locationId: string) =>
    requests(config.PAYMENTS_SERVICE_URL).get<PaymentProvidersResponse>(
      `/integrations/provider/connected?altId=${locationId}&altType=location`
    ),
}
